export default __webpack_public_path__ + "static/media/guiaIphone3.83442283.png";